export const CONTACT_METHOD_TYPE = {
  TEXT: 'text',
  CHAT: 'chat',
} as const;

export const SUBMITTED = 'submitted';

const QUESTION_PROMPT =
  "Please enter your question below and we'll let you know when an Advocate is available.";
const CONTACT_PROMT = 'How would you like us to contact you?';
const NAME_PHONE_PROMPT = 'Please enter your name and mobile phone number where we can reach you:';

export const PROMPTS = {
  QUESTION_PROMPT,
  CONTACT_PROMT,
  NAME_PHONE_PROMPT,
} as const;
